import React from 'react';

import Segmented from 'components/DesignSystem/Segmented';
import EditButton from 'components/Shared/EditButton';
import RichHtml from 'components/RichHtml';
import AlertsCollection from 'components/AlertsCollection';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import { negativePolarity, positivePolarity } from 'hooks/Meteorology/Weather/Area/About/usePolaritySelection';

import './index.scss';

export interface AboutMobileProps {
  name: string;
  description: string;
  imageSrc: string;
  hasImage: boolean;
  showPolaritySelector: boolean;
  polarity: string | undefined;
  handlePolarityChange: (polarity: string) => void;
  isAdmin: boolean;
  onEdit: () => void;
}

export default function AboutMobile({
  name,
  description,
  imageSrc,
  hasImage,
  showPolaritySelector,
  polarity,
  handlePolarityChange,
  isAdmin,
  onEdit,
}: AboutMobileProps) {
  return (
    <div className="area-about-mobile">
      <section className="aam-card">
        <header className="aam-card-header">
          <span className="aam-card-title">{name}</span>
          {showPolaritySelector && (
            <Segmented
              options={[
                { value: positivePolarity, label: 'POSITIVA' },
                { value: negativePolarity, label: 'NEGATIVA' },
              ]}
              value={polarity ?? positivePolarity}
              onChange={handlePolarityChange}
              fill={false}
              size="sm"
              ariaLabel="Polaridade"
            />
          )}
        </header>

        {hasImage ? (
          <EnlargeableImage src={imageSrc} className="aam-image" />
        ) : (
          <AlertsCollection
            alerts={[{ title: '', message: 'Imagem indisponível', variant: 'warning' }]}
          />
        )}

        <div className="aam-desc">
          <div className="aam-desc-head">
            <span className="aam-desc-label">Descrição</span>
            {isAdmin && <EditButton id="edit-description" onClick={onEdit} />}
          </div>
          <RichHtml html={description} className="aam-desc-body ql-editor" />
        </div>
      </section>
    </div>
  );
}
